import { COLORS } from 'consts/colors'
import styled from 'styled-components'
import { ChessGridBackground } from 'styles/consts'

export { LoadingOverlay } from '../styled'

export const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
`

export const MobileUploadedImageContainer = styled.div`
  position: relative;
  width: 100%;
  max-height: 235px;
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 1/1;

  ${ChessGridBackground}
`

export const MobileActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  width: 100%;
`

export const MobileActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 48px;
  background-color: ${COLORS.secondaryExtraDark};
  border: 1px solid ${COLORS.secondaryExtraDark};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  & > span {
    color: ${COLORS.white};
    font-size: 14px;
    font-weight: 600;
  }

  & > svg {
    width: 20px;
    height: 20px;

    path {
      fill: ${COLORS.white};
    }
  }

  &:hover {
    background-color: ${COLORS.secondaryDark};
    border-color: ${COLORS.secondaryDark};
  }

  &:active {
    transform: scale(0.98);
  }
`
